import { FONT_FAMILY, typography } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    container: {
      fontFamily: FONT_FAMILY,
      marginBottom: 25,
      position: 'relative'
    },
    header: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 25
    },
    unavailableMessage: {
      minHeight: 32,
      paddingButton: 0,
      border: 0,
      padding: 0,
      margin: 0,
      boxShadow: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 0,
      backgroundColor: colors.unavailable,
      textAlign: 'center',
      whiteSpace: 'break-spaces'
    },
    downLoadButton: {
      color: colors.white,
      backgroundColor: colors.primary,
      textTransform: 'uppercase',
      borderRadius: 25
    },
    printerIcon: {
      transform: 'scaleX(-1)'
    },
    printPage: {
      userSelect: 'none',
      webkitUserSelect: 'none',
      overflowY: 'scroll',
      maxHeight: '70vh',
      marginTop: 45
    },
    printContainer: {
      backgroundColor: '#fff',
      margin: 0,
      padding: '15px 45px'
    },
    printPageCancelButton: {
      borderRadius: 25,
      minWidth: 90,
      backgroundColor: colors.white,
      color: colors.primary,
      border: `1px solid ${colors.primary}`,
      textTransform: 'uppercase',
      marginRight: 15
    },
    printPageCancelPrintButton: {
      borderRadius: 25,
      minWidth: 90,
      color: colors.white,
      backgroundColor: colors.primary,
      textTransform: 'uppercase'
    },
    printPageLogo: {
      pointerEvents: 'none',
      marginBottom: 45,
      marginTop: 45
    },
    contentArea: {
      position: 'relative',
      backgroundColor: colors.white,
      minHeight: 450,
      overflowX: 'scroll'
    },
    noDataContainer: {
      container: {
        height: '198px'
      }
    },
    title: {
      fontSize: 20,
      marginBottom: 15,
      flexDirection: 'column',
      justifyContent: 'flex-end',
      color: colors.approxBlack,
      ...typography.fontBold
    }
  }
  return styles
}

export default themeStyles
